import React, { useCallback, useEffect, useState } from 'react';
import useCurrentAccount from 'src/hooks/useWalletAddress';
import WalletAddressInDesktopView from './WalletAddressInDesktopView';
import WalletAddressInMobileView from './WalletAddressInMobileView';

interface IWalletAddressProps {
  isDesktopView: boolean;
}

const WalletAddress = ({ isDesktopView }: IWalletAddressProps) => {
  const metaMaskWalletAddress = useCurrentAccount();

  const [hasCopied, setHasCopied] = useState<boolean>(false);

  const onClickCopyAddress = useCallback(() => {
    if (metaMaskWalletAddress) {
      navigator.clipboard.writeText(metaMaskWalletAddress);
      setHasCopied(true);
    }
  }, [metaMaskWalletAddress, setHasCopied]);

  useEffect(() => {
    if (hasCopied) {
      setTimeout(() => {
        setHasCopied(false);
      }, 1000);
    }
  }, [hasCopied]);

  if (!metaMaskWalletAddress) {
    return null;
  }

  if (isDesktopView)
    return (
      <WalletAddressInDesktopView
        walletAddress={metaMaskWalletAddress}
        onClickCopyAddress={onClickCopyAddress}
        hasCopied={hasCopied}
      />
    );

  return (
    <WalletAddressInMobileView
      walletAddress={metaMaskWalletAddress}
      onClickCopyAddress={onClickCopyAddress}
      hasCopied={hasCopied}
    />
  );
};

export default WalletAddress;
